import React, { createContext, useEffect, useState } from "react";
import GlobalHeader from "../../components/header";
import Footer from "../../components/footer";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import TitleIcon from "../../components/TitleIcon";
import WorkIcon from "@mui/icons-material/Work";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import ContainerCardsOwn from "../../components/ContainerCardsOwn";
import ContainerCardsInvestment from "../../components/ContainerCardsInvestment";
import FilterOwnInvestments from "../../components/Drawer/FilterOwnInvestments";
import ActionsNav from "../../components/ActionsNav";
import SnackAlert from "../../components/SnackAlert";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { validateMinMaxIsValid } from "../../utils/validations";

export const ManageInvestmentContext = createContext();

function MyInvestments() {
  const [allLoaded, setAllLoaded] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [mainData, setMainData] = useState(false);
  const [paginatedData, setPaginatedData] = useState();
  const [filteredData, setFilteredData] = useState();
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [filtersSettings, setFiltersSettings] = useState({
    price: {
      min: "",
      max: "",
    },
    profitability: {
      min: "",
      max: "",
    },
    days: {
      min: "",
      max: "",
    },
    objective: {
      min: "",
      max: "",
    },
  });

  // STATES
  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [expanded, setExpanded] = useState("panel1");
  const openMenuOrderBy = Boolean(anchorEl);
  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 9;

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };
  const handleClickOpenOrderBy = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChangeOrderBy = (value) => {
    let sortedData = [...mainData];
    if (value === "relevancia") {
      sortedData = mainData;
    } else if (value === "menorMayor") {
      sortedData = sortedData.sort(
        (a, b) =>
          parseInt(a.data.min_investment) - parseInt(b.data.min_investment)
      );
    } else if (value === "mayorMenor") {
      sortedData = sortedData.sort(
        (a, b) =>
          parseInt(b.data.min_investment) - parseInt(a.data.min_investment)
      );
    }
    setFilteredData(sortedData);
    setAnchorEl(null);
  };
  const handleCloseMenuOrderBy = () => {
    setAnchorEl(null);
  };
  const handlerSearchField = ({ target }) => {
    if (target.value.length === 0) {
      setPaginatedData(mainData);
    }
    const tempData = mainData.filter((x) =>
      x.name.toLowerCase().includes(target.value.toLowerCase())
    );
    setFilteredData(tempData);
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const handlerFilterSet = () => {
    const mockUpData = {
      price: {
        min: "",
        max: "",
      },
      profitability: {
        min: "",
        max: "",
      },
      days: {
        min: "",
        max: "",
      },
      objective: {
        min: "",
        max: "",
      },
    };

    let filteredData = mainData;

    // FILTAR INVERSIÓN MINIMA
    if (
      JSON.stringify(mockUpData.price) !== JSON.stringify(filtersSettings.price)
    ) {
      const result = validateMinMaxIsValid(
        filtersSettings.price.min,
        "Inversión mínima",
        filtersSettings.price.max,
        "Inversión máxima",
        showSnack
      );
      if (!result) {
        return;
      }
      filteredData = filteredData.filter(
        (x) =>
          parseInt(x.Project.min_investment) >= filtersSettings.price.min &&
          parseInt(x.Project.min_investment) <= filtersSettings.price.max
      );
    }

    // FILTRAR RENTABILIDAD
    if (
      JSON.stringify(mockUpData.profitability) !==
      JSON.stringify(filtersSettings.profitability)
    ) {
      const result = validateMinMaxIsValid(
        filtersSettings.profitability.min,
        "Rentabilidad mínima",
        filtersSettings.profitability.max,
        "Rentabilidad máxima",
        showSnack
      );
      if (!result) {
        return;
      }
      filteredData = filteredData.filter(
        (x) =>
          parseInt(x.Project.esti_profitability) >=
            filtersSettings.profitability.min &&
          parseInt(x.Project.esti_profitability) <=
            filtersSettings.profitability.max
      );
    }

    // FILTRAR DIAS RESTANTES
    if (
      JSON.stringify(mockUpData.days) !== JSON.stringify(filtersSettings.days)
    ) {
      const result = validateMinMaxIsValid(
        filtersSettings.days.min,
        "Días restantes mínimos",
        filtersSettings.days.max,
        "Días restantes máximos",
        showSnack
      );
      if (!result) {
        return;
      }
      filteredData = filteredData.filter(
        (x) =>
          parseInt(x.Project.daysRemaining) >= filtersSettings.days.min &&
          parseInt(x.Project.daysRemaining) <= filtersSettings.days.max
      );
    }
    // FILTRAR OBJETIVO
    if (
      JSON.stringify(mockUpData.objective) !==
      JSON.stringify(filtersSettings.objective)
    ) {
      const result = validateMinMaxIsValid(
        filtersSettings.objective.min,
        "Objetivo mínimo",
        filtersSettings.objective.max,
        "Objetivo máximo",
        showSnack
      );
      if (!result) {
        return;
      }
      filteredData = filteredData.filter(
        (x) =>
          parseInt(x.Project.objective) >= filtersSettings.objective.min &&
          parseInt(x.Project.objective) <= filtersSettings.objective.max
      );
    }

    setOpenDrawer(false);
    setFilteredData(filteredData);
  };
  const handlerChangeExpanded = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handlerResetFilters = () => {
    setFiltersSettings({
      price: {
        min: "",
        max: "",
      },
      profitability: {
        min: "",
        max: "",
      },
      days: {
        min: "",
        max: "",
      },
      objective: {
        min: "",
        max: "",
      },
    });
    setFilteredData(mainData);
  };

  useEffect(() => {
    if (!filteredData) {
      return;
    }
    let tempData = filteredData;
    tempData = tempData.slice(
      (page - 1) * ITEMS_PER_PAGE,
      page * ITEMS_PER_PAGE
    );

    setPaginatedData(tempData);
  }, [page]);

  useEffect(() => {
    if (!filteredData) {
      return;
    }
    let tempData = filteredData;
    tempData = tempData.slice(
      (page - 1) * ITEMS_PER_PAGE,
      page * ITEMS_PER_PAGE
    );
    setPaginatedData(tempData);
  }, [filteredData]);
  useEffect(() => {
    setOpenBackDrop(true);
    loadApi("investment", true, "get")
      .then((response) => {
        setAllLoaded(true);
        setPaginatedData(
          response.data.slice(
            (page - 1) * ITEMS_PER_PAGE,
            page * ITEMS_PER_PAGE
          )
        );
        setFilteredData(response.data);
        setMainData(response.data);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  }, []);

  return (
    <ManageInvestmentContext.Provider
      value={{
        openDrawer,
        toggleDrawer,
        expanded,
        handlerChangeExpanded,
        filtersSettings,
        setFiltersSettings,
        handlerFilterSet,
        handlerResetFilters,
      }}
    >
      <GlobalHeader />
      <Stack
        sx={{
          width: { xs: "100vw", sm: "95vw", md: "90vw", lg: "75vw" },
          marginInline: "auto",
          minHeight: "calc(100vh - 150px)",
          backgroundColor: { xs: "none", sm: "white" },
          py: 4,
        }}
      >
        <Stack px={{ xs: 2, md: 4 }}>
          <ActionsNav
            title="Mis Inversiones"
            icon={<WorkIcon fontSize="large" />}
            anchorEl={anchorEl}
            filteredData={filteredData}
            handleChangeOrderBy={handleChangeOrderBy}
            handleClickOpenOrderBy={handleClickOpenOrderBy}
            handleCloseMenuOrderBy={handleCloseMenuOrderBy}
            handlerSearchField={handlerSearchField}
            mainData={mainData}
            openMenuOrderBy={openMenuOrderBy}
            toggleDrawer={toggleDrawer}
            textOrder={{
              first: "Inversión mínima: menor a mayor",
              second: "Inversión máxima: mayor a menor",
            }}
          />

          {!openBackDrop && mainData.length === 0 ? (
            <Stack pt={3}>
              <Typography
                color="GrayText"
                sx={{ pt: 2, marginInline: "auto", mb: 2 }}
              >
                Aún no has realizado tu primera inversión
              </Typography>
              <Button
                LinkComponent={Link}
                to="/projects"
                variant="contained"
                sx={{
                  width: "fit-content",
                  marginInline: "auto",
                  px: 3,
                  color: "white",
                  backgroundColor: "primary.300",
                }}
              >
                Explorar
              </Button>
            </Stack>
          ) : filteredData ? (
            filteredData.length !== 0 ? (
              <>
                <Box mt={3}></Box>
                <ContainerCardsInvestment
                  data={paginatedData}
                  columns={3}
                  childSizes={{ xs: 3, sm: 1.5, md: 1, lg: 1 }}
                />
                <Pagination
                  count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
                  sx={{ marginInline: "auto", mt: 4 }}
                  page={page}
                  onChange={handlePageChange}
                />
              </>
            ) : (
              <Typography color="GrayText" sx={{ pt: 2, marginInline: "auto" }}>
                No se encontraron inversiones
              </Typography>
            )
          ) : (
            ""
          )}
        </Stack>
      </Stack>
      <FilterOwnInvestments />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      <Footer />
    </ManageInvestmentContext.Provider>
  );
}

export default MyInvestments;
